import { cmsPictureSchema } from '@/ui/cms/cms-picture/CMSPicture.schema'
import { z } from 'zod'
import { linkSchema } from '../../services/cms.schema'
import type { TwoColumnsImageVariantProps } from './TwoColumnsImage.server'

export const twoColumnsImageSchema = z.object({
  id: z.string().nonempty().optional(),
  title: z.string().nonempty().optional(),
  content: z.string().nonempty().optional(),
  picture: cmsPictureSchema.extend({
    className: z.string().optional(),
  }),
  link: linkSchema.optional(),
  pictureLink: z
    .object({
      url: z.string().nonempty(),
      opensInNewTab: z.boolean().optional(),
    })
    .optional(),
  tint: z.custom<TwoColumnsImageVariantProps['tint']>().optional(),
})

export type TwoColumnsImageSchemaType = z.infer<typeof twoColumnsImageSchema>
